import { Poll } from 'model';
import { FormValidationRules } from '../hooks/useFormValues';

export const PollEditRules: FormValidationRules<Poll> = {
	topic: {
		rules: {
			required: {
				value: true,
				message: 'Poll Topic is required'
			},
			maxLength: {
				value: 20,
				message: 'Must be less than {value} characters'
			},
			pattern: {
				value: /^\S*$/,
				message: 'Must be one word'
			}
		}
	},
	contents: {
		rules: {
			minLength: {
				value: 20,
				message: 'Must be more than {value} characters'
			},
			maxLength: {
				value: 400,
				message: 'Must be less than {value} characters'
			},
			required: {
				value: true,
				message: 'Poll question is required'
			}
		}
	}
};
